const ShimmerCard= () => {
  return (
    <div className="animate-pulse bg-white rounded-lg shadow p-3">
      {/* Image */}
      <div className="w-full h-32 bg-gray-300 rounded mb-3"></div>

      {/* Title */}
      <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>

      {/* Price */}
      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
    </div>
  );
};

export default ShimmerCard;
